import { Component } from 'opus-angular-seed-core';
import template from './template.html';

const MAX_PAGES = 7;
const ELLIPSIS = '...';

@Component({
    bindings: {
        list: '='
    },
    template
})
export default class {
    constructor ($scope) {
        this.$scope = $scope;
        this.ellipsis = ELLIPSIS;
    }

    $onInit () {
        this.buildPageItems();

        this.$scope.$watch('vm.list.pagination.currentPage', () => {
            this.buildPageItems();
        });

        this.$scope.$watch('vm.list.pagination.pageCount', () => {
            this.buildPageItems();
        });
    }

    buildPageItems () {
        if (!this.list || !this.list.pagination) {
            return;
        }

        this.pageItems = [];

        const { currentPage, pageCount } = this.list.pagination;

        if (pageCount <= MAX_PAGES) {
            this.pageItems = Array.from({ length: pageCount }, (_, i) => i + 1);
            return;
        }

        if (currentPage < 4) {
            const firstItems = Array.from({ length: 5 }, (_, i) => i + 1);
            this.pageItems = [...firstItems, this.ellipsis, pageCount];
            return;
        }

        if (currentPage >= 5 && currentPage < pageCount - 4) {
            this.pageItems = [1, this.ellipsis, currentPage - 1, currentPage, currentPage + 1, this.ellipsis, pageCount];
            return;
        }

        this.pageItems = [1, this.ellipsis, pageCount - 4, pageCount - 3, pageCount - 2, pageCount - 1, pageCount];
    }

    changePage (page) {
        this.list.pagination.currentPage = page;
        this.list.fetch();
    }

    handlePrev () {
        const { currentPage } = this.list.pagination;
        const prevPage = currentPage - 1;
        if (prevPage < 1) {
            return;
        }
        this.changePage(prevPage);
    }

    handleNext () {
        const { currentPage, pageCount } = this.list.pagination;
        const nextPage = currentPage + 1;

        if (nextPage > pageCount) {
            return;
        }

        this.changePage(nextPage);
    }

    isEllipsis (item) {
        return item === ELLIPSIS;
    }

    isCurrentPage (item) {
        const { currentPage } = this.list.pagination;
        return item === currentPage;
    }

    isFirstPage () {
        const { currentPage } = this.list.pagination;
        return currentPage === 1;
    }

    isLastPage () {
        const { currentPage, pageCount } = this.list.pagination;
        return currentPage === pageCount;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/paginationv2/index.js